import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'

import App from './App.vue'
import router from './router'
import { useUserStore } from './stores/user'
import './styles/theme.scss'
import { fitHeight } from './directives/fitHeight'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPersist)

app.use(pinia)
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.directive('fit-height', fitHeight)

app.mount('#app')

/**
 * 登录后按当前生效角色预取业务 store。
 * SYSTEM_ADMIN 与普通角色不能在应用启动时请求无权限模块，否则即使停留在合法页面也会连续弹 403。
 */
async function prefetchAuthorizedStores() {
  await router.isReady()
  const userStore = useUserStore(pinia)
  const user = await userStore.getCurrentUser()
  if (!user) return

  const jobs: Array<Promise<unknown>> = []
  if (userStore.can('emp:read')) {
    jobs.push(import('./stores/empCertificateStore').then(m => m.loadFromAPI?.()))
  }
  if (userStore.can('pay:read')) {
    jobs.push(import('./stores/employeeSalaryOverrideStore').then(m => m.loadFromAPI?.()))
    jobs.push(import('./stores/salaryStructureStore').then(m => m.loadFromAPI?.()))
    jobs.push(import('./stores/compModeStore').then(m => m.loadFromAPI?.()))
  }
  if (userStore.can('emp:contract:read')) {
    jobs.push(import('./stores/contractTypeStore').then(m => m.loadFromAPI?.()))
    jobs.push(import('./stores/contractTemplateStore').then(m => m.loadFromAPI?.()))
  }
  if (userStore.can('lrn:read')) {
    jobs.push(import('./stores/trainingRecordStore').then(m => m.loadFromAPI?.()))
  }
  await Promise.allSettled(jobs)
}

void prefetchAuthorizedStores()
